import { render } from "./ManagementContent.vue?vue&type=template&id=1d8db39b&scoped=true"
import script from "./ManagementContent.vue?vue&type=script&lang=js"
export * from "./ManagementContent.vue?vue&type=script&lang=js"

import "./ManagementContent.vue?vue&type=style&index=0&id=1d8db39b&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/solution/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d8db39b"]])

export default __exports__